import React from "react";
import { getTitleDecoration } from "utils/common";
import { formatPhoneNumber } from "utils/common";
import { ButtonAddPartner } from "assets/svg";

const ModalPartner = ({
  entry,
  list,
  openFn,
  closeFn,
  handleDeletePartner,
  setPromotionSet,
  setPartnerInfo,
  open = null,
}) => {
  const openModalAdd = (promotion_set) => {
    setPromotionSet(promotion_set);
    openFn("modal-add-partner");
  };
  const openModalUpdate = (partner) => {
    setPartnerInfo(partner);
    openFn("modal-update-partner");
  };

  const ListPartner = ({ id }) => {
    const list_partner_id = list.filter(
      (item) => +item.promotion_set_id === id && item?.action !== 2
    );
    return (
      <div className="bg-pink px-2 px-md-3 py-2">
        {list_partner_id.length > 0 ? (
          list_partner_id.map((item, index) => {
            return (
              <div key={index} className="d-flex mb-2 ">
                <div className="fs-10 fs-sm-9 lh-21 mw-42">
                  同行者{index + 1}
                </div>
                <div className="ms-2">
                  <div className="fs-14">
                    {item.last_name + " " + item.first_name}
                  </div>
                  <div className="fs-12 fs-sm-9 text-grey">
                    <div>年齢：{item.age}</div>
                    <div>性別：{item.gender == 1 ? "男性" : "女性"}</div>
                    <div>電話番号：{formatPhoneNumber(item.phone)}</div>
                  </div>
                </div>
                <div className="ms-auto text-end mw-114">
                  <div
                    onClick={() => openModalUpdate(item)}
                    className="btn-box"
                  >
                    修正
                  </div>
                  <div
                    onClick={() => handleDeletePartner(item)}
                    className="btn-box ms-1 mt-1"
                  >
                    削除
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="fs-10 fs-sm-9 lh-21 mw-42">同行者：なし</div>
        )}
      </div>
    );
  };

  return (
    open && (
      <div className="modal active">
        <div className="clap modal-body">
          <a
            className="btn-close-modal rounded-3 cursor-pointer"
            onClick={closeFn}
          >
            <svg
              width="45"
              height="45"
              viewBox="0 0 45 45"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="45" height="45" rx="5" fill="white" />
              <path
                d="M30.5931 13L32 14.4069L24.3862 22.0207L31.9586 29.5931L30.5931 31L22.9793 23.4276L15.4483 31L14 29.5931L21.5724 22.0207L14 14.4483L15.4069 13L22.9793 20.6138L30.5931 13Z"
                fill="#333333"
              />
            </svg>
          </a>
          <div className="title mt-2 text-black">同行者の確認・変更</div>

          <div className="box px-2 py-2 my-4 text-start">
            <div className="description">
              <div
                className="d-block d-md-inline-block"
                dangerouslySetInnerHTML={{
                  __html: getTitleDecoration(
                    entry?.title_decoration?.title_decoration_content
                  ),
                }}
              ></div>
              <span className="align-middle fs-14">{entry.title_login}</span>
            </div>
          </div>

          {entry.promotion_sets.map((item) => {
              return (
                <div key={item.id} className="my-2 fw-600 fs-13">
                  <div className="bg-violet px-2 px-md-3 py-1 fs-sm-12">
                    <label htmlFor={item.id} className="fs-16">
                      {item.name}
                    </label>
                  </div>

                  <ListPartner id={item.id} />

                  <a
                    className="btn-plus my-2 z-index-100"
                    onClick={() => openModalAdd(item)}
                  >
                    <span className="rounded-add">
                      <ButtonAddPartner />
                    </span>
                    {/* <i className="me-2 bi bi-plus-circle-fill"></i> */}
                    同行者を追加する
                  </a>
                </div>
              );
          })}

          <div className="text-center text-red fs-14 sp-0 fw-600">
            ※参加時間を変更する場合は、ステップ詳細から <br />
            「キャンセル」ボタンを押して、再度お申込ください。
          </div>

          <div className="my-3 text-center">
            <div
              onClick={() => openFn("modal-submit")}
              className="btn-custom red-light"
            >
              変更を反映する
            </div>
            <div onClick={closeFn} className="btn-custom mt-2">
              閉じる
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default ModalPartner;
